module.exports = __webpack_public_path__ + "img/7.8c2064e9.jpg";